import { useState } from 'react';
import { Plus, UserPlus, ListTodo } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover.jsx';
import { Button } from '@/components/ui/button.jsx';
import LeadCaptureSheet from './LeadCaptureSheet.jsx';
import ManualTaskSheet from './ManualTaskSheet.jsx';

export default function NewButton({ onSuccess }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [leadOpen, setLeadOpen] = useState(false);
  const [taskOpen, setTaskOpen] = useState(false);

  return (
    <>
      <Popover open={menuOpen} onOpenChange={setMenuOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" size="sm" className="gap-1.5">
            <Plus size={14} strokeWidth={2} />
            New
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" sideOffset={4} className="w-44 p-2 space-y-0.5">
          <button
            type="button"
            onClick={() => { setMenuOpen(false); setLeadOpen(true); }}
            className="flex w-full items-center gap-2 rounded px-2 py-1.5 text-sm text-text hover:bg-border/40"
          >
            <UserPlus size={14} strokeWidth={1.5} className="text-text-dim" />
            New lead
          </button>
          <button
            type="button"
            onClick={() => { setMenuOpen(false); setTaskOpen(true); }}
            className="flex w-full items-center gap-2 rounded px-2 py-1.5 text-sm text-text hover:bg-border/40"
          >
            <ListTodo size={14} strokeWidth={1.5} className="text-text-dim" />
            New manual task
          </button>
        </PopoverContent>
      </Popover>

      <LeadCaptureSheet
        open={leadOpen}
        onOpenChange={setLeadOpen}
        onSuccess={(result) => { setLeadOpen(false); onSuccess?.(result); }}
      />
      <ManualTaskSheet
        open={taskOpen}
        onOpenChange={setTaskOpen}
        onSuccess={() => { setTaskOpen(false); onSuccess?.(); }}
      />
    </>
  );
}
